import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-environment'

import {
  TREE,
  BRANCH,
} from 'fc-environment'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

import initialize from './initialize'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize,
})
